module.exports = __webpack_public_path__ + "files/b7a1893c38b8b2f510a6fc194b49da47.png";